import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import FileUpload from '../../../../component/FileUpload';
import classes from './style.module.scss';

const ProductUpload = ({text, placeholder, files, setFiles,required, fileName, setFileName, onChange, acceptFiles  }) => {

    const formMethods = useForm({
        mode: 'onSubmit',
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        getValues,
        trigger,
    } = formMethods;

    // const [fileName, setFileName] = useState(null);
    const [isFileUploading, setIsFileUploading] = useState(false);

    return (
        <div>
            <div className={`mt-5`}>
                <div className={classes.titleHeader}>{text}</div>
                <FileUpload
                    name="uploadResource"
                    className={`p-8 py-12 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    setError={formMethods.setError}
                    error={errors.uploadResource}
                    required={required}
                    messages={{
                        required: "File is required",
                    }}
                    maxSize={20971520}
                    maxLable= "20MB"
                    label="Upload File"
                    acceptFiles={acceptFiles}
                    fileNames={fileName}
                    setFileName={setFileName}
                    uploadedFiles={files}
                    setUploadedFiles={setFiles}
                    isFileUploading={isFileUploading}
                    placeholder={placeholder}
                    alignment={'center'}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}

export default ProductUpload